import { slicesEqualIgnoringLocalId } from '@atlaskit/editor-common/collab-agent-review-slice-compare';
import {
	computeDiffChanges,
	type ComputeDiffChangesParams,
} from '@atlaskit/editor-plugin-show-diff/calculate-diff';
import { Transform } from '@atlaskit/editor-prosemirror/transform';

/** Detect removals before smart diff can expand them into replacement ranges. */
export function isDeletionOnlyDiff(
	params: Pick<ComputeDiffChangesParams, 'originalDoc' | 'steps'>,
): boolean {
	const { changes, newDoc } = computeDiffChanges({ ...params, diffType: 'inline' });
	if (
		!changes.some((change) => change.deleted.length > 0) ||
		changes.some((change) => change.inserted.length > 0)
	) {
		return false;
	}

	// Inline diff can ignore formatting/attributes in some cohorts. Confirm
	// that removing content alone reproduces the result, ignoring ephemeral IDs.
	const deleted = new Transform(params.originalDoc);
	for (const change of [...changes].reverse()) {
		deleted.delete(change.fromA, change.toA);
	}
	return slicesEqualIgnoringLocalId(deleted.doc.slice(0), newDoc.slice(0));
}
